// extracted by mini-css-extract-plugin
export var infoItem = "_uf-2";
export var title = "_uf-0";
export var value = "_uf-1";